export default [
  {
    path: "/Webcontrol/EventsNews",
    name: "Events-News",
    component: () =>
      import("@/views/pages/Systems/WebControl/EventsNews/EventsNews.vue"),
    props: true,
    meta: {
      pageTitle: "公告資訊",
      breadcrumb: [
        {
          text: "首頁",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Webcontrol/WebLink",
    name: "WebLink",
    component: () =>
      import("@/views/pages/Systems/WebControl/WebLink/WebLink.vue"),
    props: true,
    meta: {
      pageTitle: "機關團體",
      breadcrumb: [
        {
          text: "友站連結",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Webcontrol/Advertise",
    name: "Advertise",
    component: () =>
      import("@/views/pages/Systems/WebControl/Advertise/Advertise.vue"),
    props: true,
    meta: {
      pageTitle: "友商廣告",
      breadcrumb: [
        {
          text: "首頁",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Webcontrol/GuaranteeQA",
    name: "GuaranteeQA",
    component: () =>
      import("@/views/pages/Systems/WebControl/GuaranteeQA/GuaranteeQA.vue"),
    props: true,
    meta: {
      pageTitle: "常見問答",
      breadcrumb: [
        {
          text: "履約保證",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Webcontrol/LogList",
    name: "LogList",
    component: () =>
      import("@/views/pages/Systems/WebControl/SystemLink/SystemLink.vue"),
    props: true,
    meta: {
      pageTitle: "log紀錄",
      breadcrumb: [
        {
          text: "log紀錄",
          active: true,
        },
      ],
    },
  },
  // {
  //   path: "/Webcontrol/MemberProfile",
  //   name: "MemberProfile",
  //   component: () =>
  //     import(
  //       "@/views/pages/Systems/WebControl/MemberProfile/MemberProfile.vue"
  //     ),
  //   props: true,
  //   meta: {
  //     pageTitle: "會員資料",
  //     breadcrumb: [
  //       {
  //         text: "後台管理",
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  {
    path: "/Webcontrol/FileDownload",
    name: "FileDownload",
    component: () =>
      import("@/views/pages/Systems/WebControl/FileDownload/FileDownload.vue"),
    props: true,
    meta: {
      pageTitle: "表單下載",
      breadcrumb: [
        {
          text: "表單下載",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Webcontrol/MetaTitle",
    name: "MetaTitle",
    component: () =>
      import("@/views/pages/Systems/WebControl/MetaTitle/MetaTitle.vue"),
    props: true,
    meta: {
      pageTitle: "MetaTitle",
      breadcrumb: [
        {
          text: "後台管理",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Webcontrol/BaseSearch",
    name: "BaseSearch",
    component: () =>
      import("@/views/pages/Systems/WebControl/BaseSearch/BaseSearch.vue"),
    props: true,
    meta: {
      pageTitle: "據點查詢",
      breadcrumb: [
        {
          text: "關於安新",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Webcontrol/OurMail",
    name: "OurMail",
    component: () =>
      import("@/views/pages/Systems/WebControl/OurMail/OurMail.vue"),
    props: true,
    meta: {
      pageTitle: "聯絡我們",
      breadcrumb: [
        {
          text: "聯絡我們",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Webcontrol/DisputeCase",
    name: "DisputeCase",
    component: () =>
      import("@/views/pages/Systems/WebControl/DisputeCase/DisputeCase.vue"),
    props: true,
    meta: {
      pageTitle: "糾紛案例",
      breadcrumb: [
        {
          text: "不動產知識庫",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Webcontrol/HomeImage",
    name: "HomeImage",
    component: () =>
      import("@/views/pages/Systems/WebControl/HomeImage/HomeImage.vue"),
    props: true,
    meta: {
      pageTitle: "首頁圖片",
      breadcrumb: [
        {
          text: "首頁",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Webcontrol/GuaranteeQA-W",
    name: "GuaranteeQA-W",
    component: () =>
      import("@/views/pages/Systems/WebControl/GuaranteeQA/GuaranteeQA.vue"),
    props: true,
    meta: {
      pageTitle: "問與答",
      breadcrumb: [
        {
          text: "地政士公告設定",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Webcontrol/FileDownload-W",
    name: "FileDownload-W",
    component: () =>
      import("@/views/pages/Systems/WebControl/FileDownload/FileDownload.vue"),
    props: true,
    meta: {
      pageTitle: "表單列印",
      breadcrumb: [
        {
          text: "地政士公告設定",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Webcontrol/EventsNews-W",
    name: "Events-News-W",
    component: () =>
      import("@/views/pages/Systems/WebControl/EventsNews/EventsNews.vue"),
    props: true,
    meta: {
      pageTitle: "最新消息",
      breadcrumb: [
        {
          text: "地政士公告設定",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Webcontrol/GuaranteeQA-B",
    name: "GuaranteeQA-B",
    component: () =>
      import("@/views/pages/Systems/WebControl/GuaranteeQA/GuaranteeQA.vue"),
    props: true,
    meta: {
      pageTitle: "問與答",
      breadcrumb: [
        {
          text: "代書公仲介公告設定告設定",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Webcontrol/FileDownload-B",
    name: "FileDownload-B",
    component: () =>
      import("@/views/pages/Systems/WebControl/FileDownload/FileDownload.vue"),
    props: true,
    meta: {
      pageTitle: "表單列印",
      breadcrumb: [
        {
          text: "仲介公告設定",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Webcontrol/EventsNews-B",
    name: "Events-News-B",
    component: () =>
      import("@/views/pages/Systems/WebControl/EventsNews/EventsNews.vue"),
    props: true,
    meta: {
      pageTitle: "最新消息",
      breadcrumb: [
        {
          text: "仲介公告設定",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Webcontrol/MockLoginPage",
    name: "MockLoginPage",
    component: () =>
      import("@/views/pages/Systems/WebControl/MockLogin/MockLoginPage.vue"),
    props: true,
    meta: {
      pageTitle: "外網模擬登入",
    },
  },
  {
    path: "/Webcontrol/SitemapDownload",
    name: "SitemapDownload",
    component: () =>
      import("@/views/pages/Systems/WebControl/SitemapDownload.vue"),
    props: true,
    meta: {
      pageTitle: "Sitemap下載",
    },
  },
  {
    path: "/Webcontrol/MessageManager",
    name: "MessageManager",
    component: () =>
      import(
        "@/views/pages/Systems/WebControl/MessageManager/MessageManager.vue"
      ),
    props: true,
    meta: {
      pageTitle: "訊息管理",
    },
  },
];
